import { jsx as l } from "react/jsx-runtime";
const e = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0ZM3 8c0 2.755 2.245 5 5 5s5-2.245 5-5-2.245-5-5-5-5 2.245-5 5Zm4.685 2.85v.91l-.005.01h.87v-.92c1.025-.165 1.585-.9 1.585-1.67 0-.77-.485-1.405-1.56-1.645l-.775-.18c-.4-.085-.585-.305-.585-.57 0-.35.3-.665.845-.665.7 0 .92.49.97.79l1.045-.3c-.12-.57-.545-1.25-1.525-1.43v-.935h-.87v.91c-.91.145-1.61.805-1.61 1.71 0 .815.57 1.395 1.49 1.6l.785.17c.425.095.64.315.64.605 0 .375-.32.64-.875.64-.78 0-1.14-.495-1.19-1.03l-1.055.255c.075.725.635 1.585 1.82 1.745Z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  e as Dollar
};
